// extracted by mini-css-extract-plugin
export default {"sparkle":"styles-module__sparkle___aXibi"};